import ModalLayout from "../../layout/ModalLayout.tsx";
import NewAttributeForm from "../formik/NewAttributeForm.tsx";
import {ModalType} from "./NewApplicationModal.tsx";


export default function NewAttributeModal({show, onClose, data}: ModalType) {
    return (
        <>
            {show && (
                <ModalLayout
                    title={"Add new Attribute"}
                    text={"Add a new attribute to your project"}
                    onClose={onClose}
                >
                    <NewAttributeForm onClose={onClose} data={data}/>
                </ModalLayout>
            )}
        </>
    );
}
